// Equivalent of NotFound but for users without permission to view a page
import classNames from 'classnames/bind';
import { FC } from 'react';

import { Lock } from '../../assets/icons/Icons';
import { useUser } from '../../context/PortalContext/PortalContext';
import Button from '../Button/Button';
import LogoLoader from '../LogoLoader/LogoLoader';
import styles from './noPermission.module.scss';

// implement styles

const cx = classNames.bind(styles);

interface Props {
  /** Adds padding when nav bar is present */
  hasNav?: boolean;
  /** Path to navigate to */
  href?: string;
  /** Overrides default title of the 404 page */
  title?: string;
  /** Overrides default detail text of the 404 page */
  details?: string;
}

const defaultProps: { [key: string]: string } = {
  href: '/',
  title: 'You don’t have access to this page',
  details: 'If you think you should, talk to your manager.',
};

const NoPermission: FC<Props> = ({
  hasNav = false,
  href = defaultProps.href,
  title = defaultProps.title,
  details = defaultProps.details,
}: Props) => {
  const user = useUser();

  // A refusal drawn from the cached profile is not an answer yet (see `isProvisional`): every page guard
  // renders this, so waiting here is what keeps all of them from flashing the no-access page.
  if (user?.isProvisional) {
    return <LogoLoader />;
  }

  return (
    <div className={cx('no-permission', 'page-bg', { 'has-nav': hasNav })} data-testid='no-permission'>
      {Lock}
      <h1 className={cx('title')}>{title}</h1>
      <p className={cx('details')}>{details}</p>
      <Button className={cx('button')} href={href} type='link-primary' size='large'>
        Go to Homepage
      </Button>
    </div>
  );
};

export default NoPermission;
